import { sdkCampaignOverview, sdkCampaignCreation, sdkCampaignSettings } from './ms-ads-sdk';

export const sdkPages = [
  sdkCampaignOverview,
  sdkCampaignSettings,
  sdkCampaignCreation,
];
